import { isMobile } from 'hooks';
import { PayoutType } from 'types';
import { useAppSelector } from 'store';
import { mapQuery } from 'utils/query';
import { Details } from 'components/details';
import { useDetailsQuery } from 'store/api/payout';
import { Drawer, DrawerHeader } from 'components/drawer';
import { getRightSlotApprovalDialog } from 'utils/payouts';
import { BackCategoryButton } from 'components/back-category-button';
import { isAuthCompanyUser, selectAuthUserRole } from 'store/slices/auth';
import { ReimbursementDetails as ReimbursementDetailsComponent } from 'components/reimbursement-details';

import { ReimbursementDrawerDetailsProps } from './types';

export const ReimbursementDrawerDetails = ({
  onClose,
  selectedReimbursementId,
}: ReimbursementDrawerDetailsProps) => {
  const mobile = isMobile();
  const authUserRole = useAppSelector(selectAuthUserRole);
  const isCompanyOwner = useAppSelector(isAuthCompanyUser);
  const { data, ...props } = useDetailsQuery(String(selectedReimbursementId), {
    skip: !selectedReimbursementId,
  });

  const rightSlot = getRightSlotApprovalDialog({
    data,
    authUserRole,
    isCompanyOwner,
    withNavigate: false,
    type: PayoutType.Reimbursements,
  });

  return (
    <Drawer
      hideOverlay
      opened={!!selectedReimbursementId}
      topOffset={mobile ? '10%' : '15%'}
    >
      <DrawerHeader onClose={onClose} title="Reimbursement Details" />
      <Details {...mapQuery(props)}>
        <BackCategoryButton onClose={onClose} text="Back to Reimbursements" />
        <ReimbursementDetailsComponent
          data={data}
          disableSticky
          hideBackButton
          subHeader={mobile ? rightSlot : undefined}
          rightSlot={!mobile ? rightSlot : undefined}
        />
      </Details>
    </Drawer>
  );
};
